<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card(rounded="lg")
    v-card-title.px-4
      v-spacer
      h6.ml-10.text-bold-body-l Remove patient from segment
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6

    .px-6.mb-16
      .text-lg.font-medium.mb-4 Are you sure you want to remove these patients from this segment?
      .text-md.mb-2 This patient will be removed immediately. You can’t undo this action.
      .text-md {{ $t('click_confirm_to_proceed') }}
    v-divider

    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.neutral500--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md.white--text(@click="confirm" :loading="isLoading" color="danger500" depressed) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'customers', 'segment'],
  data: () => ({
    isLoading: true,
    segmentCustomers: []
  }),
  mounted () {
    this.fetchSegment()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegment () {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/groups/${this.segment.id}`)
        .then(({ data }) => {
          this.segmentCustomers = data.customer
          this.isLoading = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    confirm () {
      this.isLoading = true
      const deleteIds = this.customers.map(cust => cust.id)
      const ids = this.segmentCustomers.filter(id => !deleteIds.includes(id)) || []
      
      this.$axios.patch(`/connect/${this.company.slug}/groups/${this.segment.id}`, { customer: ids })
        .then(() => {
          this.isEditingTitle = false
          this.showDialog = false
          this.showMessage(['success', this.$t('success_message.customers_successfully_removed_from_segment', { count: deleteIds.length })])
          this.$emit('deleted')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_remove_customer')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>